import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, CardMedia, Button, Chip, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

// ... (existing imports)

const newsArticles = [
    {
        title: "GAT Expands Operations to Singapore",
        date: "March 12, 2025",
        category: "Expansion",
        image: "https://images.unsplash.com/photo-1565967511849-76a60a516170?q=80&w=800", // Singapore Marina Bay
        summary: "Strengthening our APAC presence with a new innovation hub in the heart of Singapore's tech district.",
        content: "GrowAITech is delighted to announce the opening of our new regional headquarters in Singapore. This strategic move allows us to better serve our growing client base in the Asia-Pacific region and tap into the vibrant local talent pool. The new hub will focus on FinTech innovation and sustainable smart city solutions."
    },
    {
        title: "GAT Unveils Quantum Computing Roadmap",
        date: "February 28, 2025",
        category: "Innovation",
        image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=800&q=80",
        summary: "Pioneering the next frontier of processing power to solve complex problems at unprecedented speeds.",
        content: "Quantum computing represents the next great leap in technology. GAT is proud to announce its strategic roadmap for 2030, involving significant investments in quantum algorithms and hardware partnerships. Our goal is to leverage this power to solve unsolvable problems in drug discovery, climate modeling, and financial risk assessment."
    },
    {
        title: "Q4 Financial Results: Record Growth",
        date: "January 30, 2025",
        category: "Finance",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Fixed Finance Image
        summary: "GrowAITech reports a 150% year-over-year revenue increase, driven by strong enterprise adoption.",
        content: "Our Q4 financial results are in, and they are nothing short of spectacular. GrowAITech has achieved a record-breaking 150% YoY revenue growth. Key drivers include accelerating enterprise adoption of our cloud-native platforms and significant wins in the healthcare sector. We thank our partners and team for this incredible milestone."
    },
    {
        title: "GAT Launches 'Tech for Good' Scholarship",
        date: "January 15, 2025",
        category: "CSR",
        image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=800", // Students
        summary: "Empowering the next generation of underrepresented tech talent with full-tuition scholarships.",
        content: "Diversity drives innovation. That's why we are launching the 'Tech for Good' Scholarship program, designed to support underrepresented students pursuing degrees in Computer Science and Engineering. The program includes full tuition coverage, a laptop stipend, and a guaranteed summer internship at one of our global offices."
    },
    {
        title: "GrowAITech Launches New AI Solutions Platform",
        date: "December 15, 2025",
        category: "Product Launch",
        image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=800&q=80",
        summary: "We are excited to announce the launch of our new enterprise AI platform designed to streamline business operations.",
        content: "GrowAITech is proud to unveil its latest flagship product: an Enterprise AI Solutions Platform. This comprehensive suite of tools leverages advanced machine learning algorithms to automate complex business processes, from supply chain management to customer service. Early adopters have reported a 30% increase in operational efficiency within the first month of implementation."
    },
    {
        title: "Top Trends in Cybersecurity for 2026",
        date: "November 28, 2025",
        category: "Industry Insights",
        image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=800&q=80",
        summary: "Our experts discuss the emerging threats in the digital landscape and how businesses can stay protected.",
        content: "As we approach 2026, the cybersecurity landscape varies drastically. Our experts predict a rise in AI-driven cyber attacks and emphasize the importance of Zero Trust Architecture. This article dives deep into the necessity of quantum-resistant encryption and proactive threat hunting to safeguard corporate assets in an increasingly connected world."
    },
    {
        title: "Partnership with TechGiant Corp Announced",
        date: "October 10, 2025",
        category: "Company News",
        image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=800&q=80",
        summary: "A strategic partnership aimed at accelerating digital transformation for SMEs globally.",
        content: "In a landmark deal, GrowAITech has partnered with TechGiant Corp to co-develop cloud-native solutions tailored for Small and Medium Enterprises (SMEs). This collaboration combines TechGiant's infrastructure with our proprietary AI models, aiming to democratize access to high-end digital tools for smaller businesses worldwide."
    },
    {
        title: "Revolutionizing Agriculture with IoT",
        date: "September 22, 2025",
        category: "Case Study",
        image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?auto=format&fit=crop&w=800&q=80",
        summary: "How our smart sensors helped a local farm increase crop yield by 40% through precision irrigation.",
        content: "Our recent pilot project with GreenValley Farms demonstrated the immense power of IoT. By deploying soil moisture sensors and automated irrigation controls, the farm was able to optimize water usage and monitor crop health in real-time. The result was a record-breaking 40% increase in crop yield and a 20% reduction in water consumption."
    },
    {
        title: "GrowAITech Wins 'Best Innovation' Award",
        date: "August 15, 2025",
        category: "Awards",
        image: "https://images.unsplash.com/photo-1531545514256-b1400bc00f31?auto=format&fit=crop&w=800&q=80",
        summary: "We are honored to be recognized for our groundbreaking work in sustainable technology solutions.",
        content: "At the Annual Tech Innovators Summit, GrowAITech was awarded the prestigious 'Best Innovation' award. The jury praised our commitment to developing sustainable tech solutions that not only solve business problems but also contribute to a greener planet. This recognition fuels our passion to continue pushing the boundaries of what's possible."
    },
    {
        title: "The Future of Blockchain in Finance",
        date: "July 30, 2025",
        category: "Thought Leadership",
        image: "https://images.unsplash.com/photo-1621416894569-0f39ed31d247?auto=format&fit=crop&w=800&q=80",
        summary: "An in-depth look at how decentralized finance (DeFi) is reshaping traditional banking systems.",
        content: "Blockchain is no longer just about cryptocurrency. In this thought leadership piece, our lead blockchain architect explores the transformative potential of efficient, transparent, and secure financial transactions. From smart contracts to cross-border payments, we analyze how DeFi is challenging and improving traditional banking models."
    },
    {
        title: "Expansion",
        date: "June 12, 2025",
        category: "Expansion",
        image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
        summary: "GrowAITech opens new offices in Berlin and London to better serve our international clients.",
        content: "Marking a significant milestone in our global growth strategy, GrowAITech is thrilled to announce the opening of two new regional headquarters in Berlin, Germany, and London, UK. These offices will serve as hubs for our European operations, allowing us to provide localized support and foster closer relationships with our growing client base in the region."
    },
    {
        title: "Workshop: Introduction to Data Science",
        date: "May 20, 2025",
        category: "Events",
        image: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?auto=format&fit=crop&w=800&q=80",
        summary: "A successful community workshop training over 100 students in the basics of Python and data analysis.",
        content: "Education is at the core of our community values. Last week, we hosted a free 'Introduction to Data Science' workshop attended by over 100 enthusiastic students. The agenda covered Python basics, data visualization libraries, and a hands-on project analyzing real-world datasets. We are committed to nurturing the next generation of tech talent."
    },
    {
        title: "Sustainable Tech: Our Green Initiative",
        date: "April 22, 2025",
        category: "CSR",
        image: "https://images.unsplash.com/photo-1473951574080-01fe45ec8643?auto=format&fit=crop&w=800&q=80",
        summary: "Commitment to reducing carbon footprint by 50% through green coding practices and renewable energy servers.",
        content: "As part of our Corporate Social Responsibility (CSR), we have launched the 'Green Code' initiative. We pledge to reduce our carbon footprint by 50% by 2030. This involves optimizing our algorithms for energy efficiency, migrating to green cloud providers, and implementing strict e-waste recycling policies across all our offices."
    },
    {
        title: "GAT Establishes AI Ethics Council",
        date: "December 05, 2024",
        category: "Corporate Governance",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80",
        summary: "A new internal body dedicated to ensuring responsible and unbiased AI development.",
        content: "As artificial intelligence becomes ubiquitous, ethical considerations are paramount. GrowAITech has successfully established an independent AI Ethics Council. Composed of external ethicists, legal experts, and senior engineers, this council will vet all proprietary AI models for bias, fairness, and transparency before they are deployed to client environments."
    },
    {
        title: "Strategic 5G Alliance with TelcoGlobal",
        date: "November 20, 2024",
        category: "Partnership",
        image: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?auto=format&fit=crop&w=800&q=80",
        summary: "Accelerating the rollout of ultra-low latency applications for industrial IoT.",
        content: "Connectivity is the backbone of the digital economy. We are proud to announce a strategic alliance with TelcoGlobal to integrate their 5G private network capabilities with our Edge Computing solutions. This partnership will enable manufacturers to run autonomous robots and real-time analytics with single-digit millisecond latency."
    },
    {
        title: "Recognized as Leader in Cloud Native Computing",
        date: "October 15, 2024",
        category: "Awards",
        image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=800&q=80",
        summary: "Industry analysts name GAT a 'Visionary' in the 2024 Cloud Services Magic Quadrant.",
        content: "For the second year in a row, leading industry analysts have recognized GrowAITech as a 'Visionary' in the Cloud Native Computing space. Our proprietary 'Cloud-First' framework, which emphasizes containerization and serverless architectures, has helped over 500 enterprises reduce their infrastructure costs by an average of 35%."
    },
    {
        title: "The Future of Hybrid Work: Research Report",
        date: "September 28, 2024",
        category: "Research",
        image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=800&q=80",
        summary: "GAT releases comprehensive study on productivity and well-being in distributed teams.",
        content: "Is the office dead? Not quite, but it's changing. Our latest research report, surveying over 5,000 global knowledge workers, helps define the optimal 'Hybrid Operating Model'. The report covers tooling, culture, and asynchronous collaboration strategies that high-performing teams are using to stay ahead."
    },
    {
        title: "Saving Lives: AI Diagnostics Case Study",
        date: "August 10, 2024",
        category: "Healthcare",
        image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=800&q=80",
        summary: "How our computer vision model helps radiologists detect early-stage outliers with 99% accuracy.",
        content: "In a groundbreaking pilot with National Health Services, GAT's computer vision algorithms were used to analyze thousands of X-rays. The model successfully identified early-stage anomalies that were missed by human review, demonstrating the potential of AI to act as a powerful 'second opinion' that saves lives."
    },
    {
        title: "New Edge Computing Platform for Manufacturing",
        date: "July 22, 2024",
        category: "Product Launch",
        image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80",
        summary: "Processing data at the source: Introducing GAT EdgeOS for smart factories.",
        content: "Data transmission costs and latency are the enemies of real-time manufacturing. Meet GAT EdgeOS, our new lightweight operating platform designed to run on factory floor hardware. It allows immediate processing of sensor data using local machine learning models, sending only critical insights back to the cloud."
    },
    {
        title: "Achieved ISO 27701 Privacy Certification",
        date: "June 05, 2024",
        category: "Compliance",
        image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=800&q=80",
        summary: "Demonstrating our unwavering commitment to data privacy and global compliance standards.",
        content: "Trust is our currency. We are pleased to announce that GrowAITech has achieved ISO 27701 certification, the global standard for Privacy Information Management Systems (PIMS). This certification verifies that our processes for handling personal data meet the strictest international regulations, including GDPR and CCPA."
    },
    {
        title: "Launching Digital Twin Solutions",
        date: "May 18, 2024",
        category: "Innovation",
        image: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?auto=format&fit=crop&w=800&q=80",
        summary: "Visualizing smart cities and complex infrastructure with real-time digital replicas.",
        content: "Imagine testing a city's emergency response system without disrupting traffic. Our new Digital Twin solution allows urban planners and facility managers to create high-fidelity virtual replicas of physical assets. These 'living models' update in real-time, allowing for accurate simulation, stress testing, and predictive maintenance."
    }
];


const SectionTitle = ({ title, subtitle, light = false }) => (
    <Box mb={6} textAlign="center">
        <Typography variant="overline" sx={{ color: light ? '#69F0AE' : '#1A9E7F', fontWeight: 700, letterSpacing: 2 }}>{subtitle}</Typography>
        <Typography variant="h3" fontWeight={800} sx={{ color: light ? 'white' : '#034522', mt: 1 }}>{title}</Typography>
    </Box>
);

function NewsMedia() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [selectedArticle, setSelectedArticle] = useState(null);

    const handleReadMore = (article) => {
        setSelectedArticle(article);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedArticle(null);
    };

    return (
        <>
            {/* 🔹 HERO SECTION */}
            <Box sx={{ bgcolor: '#002613', color: 'white', pt: { xs: 15, md: 20 }, pb: { xs: 8, md: 15 }, position: 'relative', overflow: 'hidden', textAlign: 'center' }}>
                <Box sx={{ position: 'absolute', top: '-50%', left: '-20%', width: { xs: '300px', md: '800px' }, height: { xs: '300px', md: '800px' }, background: 'radial-gradient(circle, rgba(26, 158, 127, 0.15) 0%, transparent 70%)', borderRadius: '50%' }} />
                <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
                        <Typography variant="overline" sx={{ color: '#69F0AE', letterSpacing: 3, fontWeight: 700 }}>Press Room</Typography>
                        <Typography variant="h2" fontWeight={800} sx={{ mt: 2, mb: 4, fontFamily: '"Lato", sans-serif', fontSize: { xs: '2.5rem', md: '4rem' } }}>
                            News, Insights & Media
                        </Typography>
                        <Typography variant="h6" sx={{ opacity: 0.8, maxWidth: '700px', mx: 'auto', lineHeight: 1.8, fontWeight: 300, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                            Stay updated with the latest announcements, press releases, and industry insights from GrowAITech.
                        </Typography>
                    </motion.div>
                </Container>
            </Box>

            <Box sx={{ minHeight: '100vh', bgcolor: '#f4f6f8', py: { xs: 8, md: 12 } }}>
                <Container maxWidth="lg">
                    <Box mb={6}>
                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate(-1)}
                            sx={{ color: '#034522', fontWeight: 700, textTransform: 'none', fontSize: '1rem' }}
                        >
                            Back to Home
                        </Button>
                    </Box>

                    <Box mb={{ xs: 6, md: 8 }} sx={{ textAlign: 'center', py: { xs: 6, md: 8 }, bgcolor: '#fff', borderRadius: 4, boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
                        <Typography variant="overline" color="primary" fontWeight={700}>Live & Virtual</Typography>
                        <Typography variant="h3" fontWeight={800} color="#034522" mb={4}>Upcoming Events</Typography>
                        <Grid container spacing={4} justifyContent="center" px={4}>
                            {[
                                { title: "AI in Healthcare Summit", date: "Jan 15, 2026", loc: "London, UK", type: "Keynote" },
                                { title: "Global DevCon 2025", date: "Feb 22, 2026", loc: "Virtual", type: "Workshop" },
                                { title: "Sustainable Tech Expo", date: "Mar 10, 2026", loc: "Berlin, DE", type: "Panel" }
                            ].map((evt, i) => (
                                <Grid item xs={12} md={4} key={i}>
                                    <Box sx={{ p: 3, border: '1px solid #eee', borderRadius: 2, textAlign: 'left', borderLeft: '4px solid #1A9E7F' }}>
                                        <Chip label={evt.type} size="small" sx={{ mb: 1, bgcolor: '#E8F5E9', color: '#1A9E7F', fontWeight: 700 }} />
                                        <Typography variant="h6" fontWeight={700} gutterBottom>{evt.title}</Typography>
                                        <Box display="flex" gap={2} color="text.secondary" fontSize="0.9rem">
                                            <Typography variant="body2">📅 {evt.date}</Typography>
                                            <Typography variant="body2">📍 {evt.loc}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={{
                            hidden: { opacity: 0 },
                            visible: {
                                opacity: 1,
                                transition: {
                                    staggerChildren: 0.1
                                }
                            }
                        }}
                    >
                        <Grid container spacing={4}>
                            {newsArticles.concat([
                                {
                                    title: "Navigating the Metaverse",
                                    date: "March 05, 2025",
                                    category: "Opinion",
                                    image: "https://images.unsplash.com/photo-1614728263952-84ea256f9679?auto=format&fit=crop&w=800&q=80",
                                    summary: "Is the Metaverse just hype or the next internet? Our Digital Strategy Lead weighs in.",
                                    content: "Virtual reality is becoming more accessible, but is it ready for enterprise adoption? We explore the practical use cases of the Metaverse in training, simulation, and remote collaboration, separating the marketing fluff from the tangible business value."
                                },
                                {
                                    title: "GAT Accredited as Top Employer",
                                    date: "February 14, 2025",
                                    category: "Culture",
                                    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80",
                                    summary: "We are thrilled to be certified as a Great Place to Work for the third consecutive year.",
                                    content: "Our people are our power. This accreditation is a testament to our inclusive culture, continuous learning opportunities, and commitment to work-life balance. Join us as we continue to build a workplace where innovation thrives."
                                },
                                {
                                    title: "Legacy System Migration Guide",
                                    date: "January 20, 2025",
                                    category: "Whitepaper",
                                    image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=800&q=80",
                                    summary: "Download our comprehensive guide on migrating monolithic architectures to microservices.",
                                    content: "Legacy modernization is the biggest challenge for established enterprises. This whitepaper outlines a step-by-step strategy for decomposing monoliths, managing data consistency, and ensuring zero downtime during the transition to cloud-native microservices."
                                }
                            ]).map((article, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <motion.div
                                        variants={{
                                            hidden: { opacity: 0, y: 20 },
                                            visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
                                        }}
                                        whileHover={{ y: -8 }}
                                    >
                                        <Card sx={{ height: '100%', borderRadius: 4, overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.08)', border: 'none', display: 'flex', flexDirection: 'column' }}>
                                            <Box sx={{ position: 'relative' }}>
                                                <CardMedia
                                                    component="img"
                                                    height="200"
                                                    image={article.image}
                                                    alt={article.title}
                                                    sx={{ objectFit: 'cover' }}
                                                />
                                                <Chip
                                                    label={article.category}
                                                    size="small"
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 16,
                                                        left: 16,
                                                        bgcolor: 'rgba(255,255,255,0.9)',
                                                        color: '#034522',
                                                        fontWeight: 700
                                                    }}
                                                />
                                            </Box>
                                            <CardContent sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                                <Box display="flex" alignItems="center" gap={1} mb={2} color="text.secondary">
                                                    <CalendarTodayIcon sx={{ fontSize: 16 }} />
                                                    <Typography variant="caption" fontWeight={600}>{article.date}</Typography>
                                                </Box>
                                                <Typography variant="h6" fontWeight={800} gutterBottom sx={{ lineHeight: 1.3, mb: 2, height: '2.6em', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                                                    {article.title}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 3, height: '4.5em', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
                                                    {article.summary}
                                                </Typography>
                                                <Button
                                                    onClick={() => handleReadMore(article)}
                                                    variant="text"
                                                    sx={{ mt: 'auto', color: '#1A9E7F', fontWeight: 700, p: 0, alignSelf: 'flex-start', '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' } }}
                                                >
                                                    Read More →
                                                </Button>
                                            </CardContent>
                                        </Card>
                                    </motion.div>
                                </Grid>
                            ))}
                        </Grid>
                    </motion.div>


                    {/* 🔹 NEW: FEATURED IN SECTION */}
                    <Box sx={{ py: 10, bgcolor: 'white', borderTop: '1px solid #eee', borderBottom: '1px solid #eee', mb: 10 }}>
                        <Container maxWidth="lg">
                            <Typography variant="h6" align="center" color="text.secondary" fontWeight={700} sx={{ textTransform: 'uppercase', letterSpacing: 3, mb: 6, opacity: 0.7 }}>
                                As Featured In
                            </Typography>
                            <Grid container spacing={4} justifyContent="center" alignItems="center">
                                {['Forbes', 'TechCrunch', 'Wired', 'Bloomberg', 'The Verge', 'VentureBeat'].map((brand, i) => (
                                    <Grid item xs={6} md={2} key={i}>
                                        <Typography variant="h5" align="center" sx={{ color: '#ccc', fontWeight: 900, fontSize: '1.5rem', '&:hover': { color: '#034522', cursor: 'default' }, transition: '0.3s' }}>
                                            {brand}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Container>
                    </Box>

                    {/* 🔹 NEW: MULTIMEDIA HUB */}
                    <Box sx={{ py: { xs: 8, md: 15 }, bgcolor: '#002613', color: 'white', borderRadius: 4, mb: 10, px: { xs: 2, md: 6 } }}>
                        <Container maxWidth="lg">
                            <SectionTitle title="Multimedia Hub" subtitle="Listen & Watch" light />
                            <Grid container spacing={6}>
                                {/* Podcast Section */}
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h5" fontWeight={700} mb={4} display="flex" alignItems="center" gap={2}>
                                        <span style={{ fontSize: '2rem' }}>🎙️</span> GAT TechTalks Podcast
                                    </Typography>
                                    {[
                                        { title: "Ep 42: The Ethics of Generative AI", duration: "45 min", guest: "Dr. Sarah Connors" },
                                        { title: "Ep 41: Scaling Kubernetes for Millions", duration: "38 min", guest: "Rajeev Singh" },
                                        { title: "Ep 40: Zero Trust Security Explained", duration: "52 min", guest: "Amanda Lee" }
                                    ].map((ep, i) => (
                                        <Box key={i} sx={{ display: 'flex', alignItems: 'center', p: 3, mb: 2, bgcolor: 'rgba(255,255,255,0.05)', borderRadius: 3, transition: '0.3s', '&:hover': { bgcolor: 'rgba(255,255,255,0.1)', cursor: 'pointer' } }}>
                                            <Box sx={{ width: 50, height: 50, borderRadius: '50%', bgcolor: '#1A9E7F', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 2, flexShrink: 0 }}>
                                                <Typography variant="body1">▶</Typography>
                                            </Box>
                                            <Box flex={1}>
                                                <Typography variant="subtitle1" fontWeight={700} color="white">{ep.title}</Typography>
                                                <Typography variant="caption" sx={{ color: '#aaa' }}>{ep.guest} • {ep.duration}</Typography>
                                            </Box>
                                        </Box>
                                    ))}
                                    <Button variant="outlined" sx={{ mt: 2, color: '#69F0AE', borderColor: '#69F0AE', borderRadius: 50 }}>
                                        View All Episodes
                                    </Button>
                                </Grid>

                                {/* Webinar Section */}
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h5" fontWeight={700} mb={4} display="flex" alignItems="center" gap={2}>
                                        <span style={{ fontSize: '2rem' }}>📺</span> Latest Webinars
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {[
                                            { title: "Migrating to Cloud Native", img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=400&q=80" },
                                            { title: "Building Resilient APIs", img: "https://images.unsplash.com/photo-1555421689-d68471e189f2?auto=format&fit=crop&w=400&q=80" }
                                        ].map((web, i) => (
                                            <Grid item xs={12} sm={6} key={i}>
                                                <Box sx={{ position: 'relative', borderRadius: 3, overflow: 'hidden', aspectRatio: '16/9', cursor: 'pointer', '&:hover img': { transform: 'scale(1.1)' } }}>
                                                    <Box component="img" src={web.img} sx={{ width: '100%', height: '100%', objectFit: 'cover', transition: '0.5s' }} />
                                                    <Box sx={{ position: 'absolute', inset: 0, bgcolor: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <Box sx={{ width: 40, height: 40, bgcolor: 'rgba(255,255,255,0.9)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'black' }}>▶</Box>
                                                    </Box>
                                                    <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, p: 2, background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)' }}>
                                                        <Typography variant="subtitle2" fontWeight={700}>{web.title}</Typography>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Container>
                    </Box>

                    {/* 🔹 EXTENDED: PRESS KIT & NEWSLETTER */}
                    <Box sx={{ mt: { xs: 8, md: 15 }, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
                        {/* Press Kit */}
                        <Box flex={1} sx={{ p: 5, bgcolor: '#002613', color: 'white', borderRadius: 4, position: 'relative', overflow: 'hidden' }}>
                            <Box sx={{ position: 'absolute', top: 0, right: 0, width: '200px', height: '100%', background: 'linear-gradient(90deg, transparent, rgba(29, 233, 182, 0.1))' }} />
                            <Typography variant="h4" fontWeight={800} mb={2}>Media Kit</Typography>
                            <Typography variant="body1" sx={{ opacity: 0.8, mb: 4, lineHeight: 1.8 }}>
                                Access our official brand assets, including high-res logos, leadership bios, and brand guidelines for press usage.
                            </Typography>
                            <Button variant="outlined" sx={{ color: '#69F0AE', borderColor: '#69F0AE', borderRadius: 50, px: 4 }}>
                                Download Assets
                            </Button>
                        </Box>

                        {/* Newsletter */}
                        <Box flex={1} sx={{ p: 5, bgcolor: '#fff', borderRadius: 4, boxShadow: '0 10px 40px rgba(0,0,0,0.05)' }}>
                            <Typography variant="h4" fontWeight={800} color="#034522" mb={2}>Stay Ahead</Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                                Subscribe to our monthly intelligence briefing. No spam, just cutting-edge tech insights.
                            </Typography>
                            <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap={2}>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    style={{ flex: 1, padding: '12px 20px', borderRadius: '50px', border: '1px solid #ccc', outline: 'none' }}
                                />
                                <Button variant="contained" sx={{ bgcolor: '#034522', borderRadius: 50, px: 4, fontWeight: 700 }}>
                                    Subscribe
                                </Button>
                            </Box>
                        </Box>
                    </Box>

                    {/* Article Dialog */}
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        maxWidth="md"
                        fullWidth
                        PaperProps={{ sx: { borderRadius: 3 } }}
                    >
                        {selectedArticle && (
                            <>
                                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 3 }}>
                                    <Typography variant="h5" fontWeight={700} color="#034522">
                                        {selectedArticle.title}
                                    </Typography>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </DialogTitle>
                                <DialogContent sx={{ p: 4, pt: 0 }}>
                                    <Box
                                        component="img"
                                        src={selectedArticle.image}
                                        sx={{ width: '100%', borderRadius: 2, mb: 3, maxHeight: 400, objectFit: 'cover' }}
                                    />
                                    <Box display="flex" gap={2} mb={3}>
                                        <Chip label={selectedArticle.category} color="primary" variant="outlined" />
                                        <Typography variant="subtitle1" color="text.secondary" sx={{ display: 'flex', alignItems: 'center' }}>
                                            {selectedArticle.date}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                                        {selectedArticle.content}
                                    </Typography>
                                </DialogContent>
                            </>
                        )}
                    </Dialog>
                </Container>
            </Box>
        </>
    );
}

export default NewsMedia;
